import { fetchWithAuth } from '../helpers';

const getAll = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/grades/`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const create = (grade: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/grades/`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(grade)
  })
    .then(handleResponse);
};

const update = (grade: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/grades/${grade.id}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify(grade)
  })
    .then(handleResponse);
};

const remove = (id: number) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/grades/${id}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" }
  })
    .then(handleResponse);
};

function handleResponse(response: any) {
  return response.text().then((text: string) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (error) {
      data = text;
    }

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

export const gradeService = {
  getAll,
  create,
  update,
  remove
};
